/* eslint-disable no-empty-pattern */
import kitsu from '@plugins/kitsu';
import http from '@plugins/axios';
import { queryString } from '@utils/format';
let $ajax;

export const state = {
  instrumens: null,
};

export const mutations = {
  SET_INSTRUMENS(state, newValue) {
    state.instrumens = newValue;
  },
};

export const actions = {
  async fetch({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return await http
      .get(`/psp/i/${id}/kp-pa-koordinator-laporan?${queryString(payload.params)}`)
      .then(({ data }) => data);
  },

  async list({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/kp-pa-koordinator-laporan`,
    });
    return await $ajax.get('/koordinator', { params: payload.params });
  },

  async listSekolah({ rootState }, payloads) {
    const id = rootState.auth.instansi_id;
    return await http.get(`/psp/i/${id}/kp-pa-koordinator-laporan/sekolah/${payloads.id}`).then(({ data }) => data);
  },

  async fetchDetail({ rootState }, payload) {
    const id = rootState.auth.instansi_id;

    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/kp-pa-koordinator-laporan/koordinator`,
    });

    return await $ajax.get(`/${payload.id}?${queryString(payload.params)}`);
  },

  async fetchLaporan({ rootState }, payload) {
    const id = rootState.auth.instansi_id;

    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/kp-pa-koordinator-laporan`,
    });

    return await $ajax.get(`/${payload.id}`);
  },

  async fetchInstrumen({ rootState, state, commit }) {
    const id = rootState.auth.instansi_id;

    if (state.instrumens) {
      return state.instrumens;
    }

    const instrumens = await http.get(`/psp/i/${id}/kp-pa-koordinator-laporan/instrumen`).then(({ data }) => data);

    commit('SET_INSTRUMENS', instrumens);

    return instrumens;
  },

  cekRekaman({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return http.get(`/psp/i/${id}/koordinator-laporan/cek-rekaman?${queryString(payload)}`).then(({ data }) => data);
  },

  update({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return http.post(`/psp/i/${id}/kp-pa-koordinator-laporan/update`, payload.params).then(({ data }) => data);
  },

  upload({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return http.post(`/psp/i/${id}/kp-pa-koordinator-laporan/berkas-insert`, payload.params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  delete({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return http.post(`/psp/i/${id}/kp-pa-koordinator-laporan/berkas-delete/${payload.id}`);
  },

  createProgres({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return http.post(`/psp/i/${id}/kp-pa-koordinator-laporan/progres/create`, payload.params).then(({ data }) => data);
  },

  updateProgres({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return http
      .post(`/psp/i/${id}/kp-pa-koordinator-laporan/progres/${payload.id}/update`, payload.params)
      .then(({ data }) => data);
  },
};
